import i18n from '@/plugins/i18n'
import { PUBLIC_REDUCED_LAYOUT, PUBLIC_REDUCED_LAYOUT_DYNAMIC } from '@/constants/layouts'
import { component } from 'vue-inline-svg'

export default [
/*   {
    path: 'iniciose',
    name: 'Login',
    component: () => import('@/components/views/SignIn.vue'),
    meta: {
      layout: 'PublicReducedLayout',
      title: {
        text: i18n.t('account.login.title')
      },
      i18n: 'public/views/account/login'
    }
  }, */
  {
    path: 'peticion-actualizar-contrasena',
    name: 'PasswordUpdateEmail',
    component: () => import('@/components/views/account/PasswordUpdateEmail.vue'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('account.password-update.update-password')
        }
      },
      i18n: 'public/views/account/password-update'
    }
  },
  {
    path: 'confirmar-cuenta',
    name: 'ConfirmEmail',
    component: () => import('@/components/views/account/ConfirmEmail.vue'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('account.confirm-email')
        }
      },
      i18n: 'public/views/account/password-update'
    }
  },
  {
    path: 'establecer-email',
    name: 'SetEmail',
    component: () => import('@/components/views/account/SetEmail.vue'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('account.setEmail')
        }
      },
      i18n: 'public/views/account/password-update'
    }
  },
  {
    path: 'registro-correcto',
    name: 'RegisterPostScreen',
    component: () => import('@/components/views/account/RegisterPostScreen.vue'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      i18n: 'public/views/account/password-update',
			title: {
        text () {
          return i18n.t('signup.titleok')
        }
      },
    }
  },
  {
    path: 'kickout',
    name: 'Kickout',
    component: () => import('@/components/views/account/Kickout.vue'),
    meta: {
      title: {
        text () {
          return i18n.t('kickout.title')
        }
      },
      layout: PUBLIC_REDUCED_LAYOUT_DYNAMIC,
      i18n: 'public/views/account/password-update'
    }
  },
  {
    path: 'cerrar-sesion',
    name: 'Cerrar sesión',
    component: () => import('@/components/views/account/SignedOut.vue'),
    meta: {
      title: {
        text () {
          return i18n.t('logOff')
        }
      },
      layout: PUBLIC_REDUCED_LAYOUT_DYNAMIC
    }
  },
  {
    path: 'actualizar-contrasena',
    name: 'UpdatePassword',
    component: () => import('@/components/views/account/PasswordUpdate.vue'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('account.password-update.update-password')
        }
      },
      i18n: 'public/views/account/password-update'
    }
  },
  {
    path: 'reactivar',
    name: 'Reactivate',
    component: () => import('@/components/public/account/ReenableAccount.vue'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('reenable-account')
        }
      }
    }
  },
	{
		path: 'actualizar-datos',
		name: 'UpdateData',
		component: () => import('@/components/views/account/UpdateRequiredData.vue'),
		meta: {
			layout: PUBLIC_REDUCED_LAYOUT,
			title: {
				text () {
					return i18n.t('update-required-data.save')
				}
			},
			i18n: 'public/views/account/update-required-data'
		}
	}
]


// WEBPACK FOOTER //
// ./src/router/routes/account.routes.js